<ng-container *ngIf="!loading; else loadingBlock">
  <div class="product-category-list">
    <ul class="list--buttons">
      <li *ngFor="let category of productCategories" class="list__item button button--category" (click)="onCategoryClick(category)">
        <i class="icon icon--lg icon-{{ category.icon }}"></i>
        <span>{{ category.title }}</span>
      </li>
      <li class="list__item button button--category" (click)="onCategoryClick(null)">
        <i class="icon icon--lg icon-category-all"></i>
        <span>{{ "general.label.view_all" | translate }}</span>
      </li>
    </ul>
  </div>
</ng-container>

<ng-template #loadingBlock>
  <div class="product-category-list loading">
    <ul class="list--buttons">
      <li class="list__item button button--category" *ngFor="let skeletons of [] | range: 4">
        <i class="icon icon--lg icon-category-all"></i>
        <span>{{ "general.label.view_all" | translate }}</span>
      </li>
    </ul>
  </div>
</ng-template>
